var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
import { Storage } from '../../storage';
import { PropertyChangeEvent } from '../../events';
//namespace Pacem.Components {
let PacemDataElement = class PacemDataElement extends PacemEventTarget {
    constructor(storage = new Storage()) {
        super();
        this.storage = storage;
        this._handle = 0;
        this._flag = false;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'persistAs':
                if (!Utils.isNullOrEmpty(old)) {
                    this.storage.removeProperty(old);
                }
                if (first === true && !Utils.isNullOrEmpty(val)) {
                    this.model = this.storage.getPropertyValue(val) ?? this.model;
                }
                break;
            case 'model':
                const debounce = this.debounce, throttle = this.throttle, emit = () => {
                    this.dispatchEvent(new PropertyChangeEvent({ propertyName: name, oldValue: old, currentValue: val, firstChange: first }));
                };
                if (debounce > 0 && !first) {
                    if (throttle) {
                        if (this._flag)
                            return;
                        this._flag = true;
                        emit();
                        this._handle = window.setTimeout(() => { this._flag = false; }, debounce);
                    }
                    else {
                        clearTimeout(this._handle);
                        this._handle = window.setTimeout(emit, debounce);
                    }
                }
                else {
                    emit();
                }
                // persist
                if (!first && !Utils.isNullOrEmpty(this.persistAs)) {
                    if (Utils.isNull(val))
                        this.storage.removeProperty(this.persistAs);
                    else
                        this.storage.setPropertyValue(this.persistAs, val, true);
                }
                break;
        }
    }
};
__decorate([
    Watch({ emit: false /* in order to debounce the propertychange emit */, converter: PropertyConverters.Eval })
], PacemDataElement.prototype, "model", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemDataElement.prototype, "persistAs", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemDataElement.prototype, "debounce", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.BooleanStrict })
], PacemDataElement.prototype, "throttle", void 0);
PacemDataElement = __decorate([
    CustomElement({ tagName: P + '-data' })
], PacemDataElement);
export { PacemDataElement };
//}
